var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6599 0C14.4099 0 14.1499 0.1 13.9599 0.29L12.1299 2.12L15.8799 5.87L17.7099 4.04C18.0999 3.65 18.0999 3.02 17.7099 2.63L15.3699 0.29C15.1699 0.09 14.9199 0 14.6599 0ZM11.06 6.02002L11.98 6.94002L2.92 16H2V15.08L11.06 6.02002ZM0 14.25L11.06 3.19L14.81 6.94L3.75 18H0V14.25Z",
    fill: "#1D6FE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.e2af85e8193a15efc732b615fbbb6829.svg";
export { ForwardRef as ReactComponent };